<template>
    <main-layout class="bg-gray-100 min-h-screen flex flex-col">

      <!-- Header dégradé -->
      <div class="bg-gradient-to-b from-secondary to-primary">
        <app-header icon="docs" class="text-white pt-4 px-4">
          <h1 class="text-2xl flex items-center gap-3">Assemblage</h1>
        </app-header>

        <!-- Barre d’actions (retour) -->
        <action-bar :back="{name: 'home'}" class="px-4 pb-6"></action-bar>
      </div>

      <!-- Contenu principal -->
      <div class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 overflow-y-auto shadow-xl pb-28">
        <div class="m-2 shadow-2xl rounded-xl overflow-hidden mb-8 bg-white">
          <form id="assemblage" class="p-4 md:p-6 space-y-6">

            <!-- ACQUÉREUR -->
            <section class="space-y-3">
              <h2 class="text-lg uppercase text-secondary font-semibold">ACQUÉREUR</h2>

              <div class="flex flex-col">
                <label class="label">Raison sociale <span class="text-alert">*</span></label>
                <!-- v-select : on garde les props/événements -->
                <v-select
                  id="id_detenteur"
                  :on-change="changeDet"
                  :options="detenteursFiltred"
                  :filterable="false"
                  @search="onSearch"
                  class="w-full"
                />
              </div>
            </section>

            <!-- ÉQUIPEMENT INSTALLÉ -->
            <section class="space-y-3">
              <h2 class="text-lg uppercase text-secondary font-semibold">ÉQUIPEMENT INSTALLÉ</h2>

              <label class="label">Type <span class="text-alert">*</span></label>
              <!-- Radios stylées : inputs gardés, labels cliquables -->
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <input
                    v-model="type_equipement"
                    required
                    type="radio"
                    name="type_equipement"
                    id="radio-clim"
                    value="Climatisation"
                    class="sr-only peer"
                  />
                  <label
                    for="radio-clim"
                    class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                           peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                           flex items-center justify-between"
                  >
                    <span>Climatisation</span>
                  </label>
                </div>

                <div>
                  <input
                    v-model="type_equipement"
                    required
                    type="radio"
                    name="type_equipement"
                    id="radio-pompe"
                    value="Pompe à chaleur"
                    class="sr-only peer"
                  />
                  <label
                    for="radio-pompe"
                    class="!text-sm block rounded-lg px-4 py-3 bg-gray-200 text-gray-700 cursor-pointer transition
                           peer-checked:bg-vert peer-checked:text-white peer-checked:shadow
                           flex items-center justify-between"
                  >
                    <span>Pompe à chaleur</span>
                  </label>
                </div>
              </div>

              <div class="flex flex-col">
                <label class="label">Fluide frigorigène <span class="text-alert">*</span></label>
                <select v-model.number="id_fluide" name="id_fluide" id="fluide" class="input">
                  <option selected disabled>Sélectionnez un fluide</option>
                  <option value="4">R-134a</option>
                  <option value="8">R-32</option>
                  <option value="19">R-410A</option>
                </select>
              </div>
            </section>

            <!-- INFORMATIONS -->
            <section class="space-y-3">
              <h2 class="text-lg uppercase text-secondary font-semibold">INFORMATIONS</h2>

              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="flex flex-col">
                  <label class="label">Période de validité du contrat (en mois) <span class="text-alert">*</span></label>
                  <input title="validatedRange" v-model.number="validite" name="periode_validite" type="number" class="input" />
                </div>

                <div class="flex flex-col md:col-span-2">
                  <label class="label">Autres détails</label>
                  <textarea
                    title="otherDetails"
                    v-model="details"
                    name="remarque"
                    maxlength="255"
                    class="input min-h-[110px] resize-y"
                  ></textarea>
                </div>
              </div>
            </section>

            <!-- SIGNATURE -->
            <section class="space-y-4">
              <h2 class="text-lg uppercase text-secondary font-semibold">SIGNATURE</h2>

              <div class="flex flex-col">
                <label class="label">Nom acquéreur <span class="text-alert">*</span></label>
                <input
                  title="clientName"
                  v-model="nom_acquereur"
                  type="text"
                  name="nom_acquereur"
                  required
                  maxlength="255"
                  class="input"
                />
              </div>

              <!-- Bouton principal (garde id, href, @click et le 'disabled' pour compat) -->
              <a
                class="btn add btn-full inline-flex items-center justify-center gap-2 rounded-lg px-4 py-3 shadow-sm hover:shadow transition"
                id="main-action"
                :class="[
                  contratIsValid ? 'bg-primary text-white' : 'bg-gray-300 text-gray-500 italic pointer-events-none disabled'
                ]"
                href="javascript: void 0"
                @click.prevent="triggerSignature"
              >
                <i class="icon-checktodo"></i>
                <span class="text-sm sm:text-base">
                  <strong>Signer et clôturer</strong> le contrat d'assemblage
                </span>
              </a>

              <!-- Modal signature (inchangé) -->
              <signature-modal
                v-show="showModal"
                :signature="signature"
                :clearOnClose="true"
                @signatureUpdated="updateSignature"
                @close="showModal = false"
              />
            </section>

          </form>
        </div>
      </div>

    </main-layout>
  </template>


<script>
    import Detenteur from '../../../js/models/Detenteur'
    import Assemblage from '../../../js/models/ContratAssemblage'
    import SignatureModal from '../../common/SignatureModal.vue'

    import vSelect from 'vue-select'

    export default {

        data() {
            return {
                detenteursOpt: [],
                detenteursFiltred: [],
                id_detenteur: null,
                type_equipement: null,
                id_fluide: null,
                validite: null,
                details: null,
                nom_acquereur: null,
                signature: null,
                detenteurs: [],
                showModal: false
            }
        },

        methods: {

            sendForm() {

                let data = this.$data;
                let contrat = new Assemblage;

                if (document.getElementById('main-action').classList.contains('disabled')) {

                    swal('Fiche incomplète', 'Veuillez finir de remplir la fiche avant de la clôturer', 'warning')

                } else {

                    contrat
                        .saveContrat(data)
                        .then(() => {
                            this.$router.push('home');
                            swal("Contrat d'assemblage terminé", "le contrat d'assemblage a bien été généré", 'success')
                        })
                        .catch(() => {
                            swal("Erreur", "une erreur s'est produite lors de l'enregistrement du contrat d'assemblage", 'error')
                        })

                }

            },

            triggerSignature() {
                if( this.contratIsValid) {
                    this.showModal = true
                }  else {
                    swal('Fiche incomplète', 'Veuillez finir de remplir la fiche avant de la clôturer', 'warning')
                }
            },

            changeDet(val) {
                this.id_detenteur = val.value
            },

            fetchDetenteurs() {
                Detenteur.getList().then(data => {

                    let dets = _.sortBy(data,  [det => det.raison_sociale.toUpperCase()]);

                    this.detenteursOpt = dets.map(det => {
                        let label = det.raison_sociale;
                        label += (det.code_client) ? ' (' + det.code_client + ') - ' : ' - ';
                        label += det.ville + ' / ' + det.code_postal;

                        return {
                            value: det.id,
                            label
                        }
                    });

                    this.detenteursFiltred = this.detenteursOpt.slice(0, 20);

                })
            },

            onSearch(str) {
                str = this.normalize(str);

                this.detenteursFiltred = this.detenteursOpt.filter( det =>  {
                    if(this.normalize(det.label).includes(str)) { return det }
                }).slice(0, 20)
            },

            normalize(s) {
                let r = s.toLowerCase();

                r = r.replace(new RegExp(/\s/g),"");
                r = r.replace(new RegExp(/[àáâãäå]/g),"a");
                r = r.replace(new RegExp(/æ/g),"ae");
                r = r.replace(new RegExp(/ç/g),"c");
                r = r.replace(new RegExp(/[èéêë]/g),"e");
                r = r.replace(new RegExp(/[ìíîï]/g),"i");
                r = r.replace(new RegExp(/ñ/g),"n");
                r = r.replace(new RegExp(/[òóôõö]/g),"o");
                r = r.replace(new RegExp(/œ/g),"oe");
                r = r.replace(new RegExp(/[ùúûü]/g),"u");
                r = r.replace(new RegExp(/[ýÿ]/g),"y");
                r = r.replace(new RegExp(/\W/g),"");

                return r;
            },

            updateSignature(data) {
                this.signature = data;
                this.sendForm()
            }

        },

        computed: {
            contratIsValid() {
                return (this.id_detenteur && this.type_equipement && this.id_fluide && this.validite && this.nom_acquereur);
            }
        },

        mounted() {
            this.fetchDetenteurs()
        },

        components: {
            SignatureModal,
            vSelect
        }

    }

</script>

<style scoped>

    #main-action.disabled {
        background-color: #e2e2e2;
        color: #999;
        font-style: italic;
    }

    #main-action{
        margin-left: 0;
        margin-bottom: 20px;
    }

    #assemblage {
        padding-top: 5px;
    }

    #assemblage h2 {
        margin-top: 10px;
        margin-bottom: 20px;
    }

    #assemblage .btn-signature {
        background-color: #5698d2;
        color: white;
        width: 120px;
        padding-left: 20px;
        margin: auto;
        margin-top: 15px;
        margin-bottom: 20px;
    }

    #assemblage .btn-signature i {
        right: 0;
        top: 50%;
        margin-top: -16px;
        font-size: 3rem;
    }

    #assemblage div.radio {
        width: 100%;
        float: none;
    }

    #assemblage div.radio label {
        width: 100%;
    }

    div.radio label {
        display: block;
        position: relative;
        height: 50px;
        width: 100px;
        border-radius: 5px;
        background-color: #e2e2e2;
        color: #999;
        padding-left: 20px;
        line-height: 3.5;
        transition: all 250ms ease;
    }

    div.radio input {
        display: none;
    }

    div.radio {
        display: block;
        float: left;
        margin-right: 20px;
        margin-bottom: 15px;
    }

    #assemblage div.radio {
        width: 100%;
        float: none;
    }

    label {
        font-size: 1.4rem;
        text-transform: uppercase;
        margin-bottom: 5px;
        display: block;
        color: #666;
    }

    div.radio label i {
        position: absolute;
        right: 10px;
        top: 15px;
        font-size: 2rem;
        color: #999;
    }

    div.radio input:checked + label {
        background-color: #86bc24;
        color: #fff;
    }

    div.radio input:checked + label i {
        color: #fff;
    }
</style>



// WEBPACK FOOTER //
// ContratAssemblage.vue?b3b586fe